export default [
  {
    index: 0,
    key: 'none',
    transportType: 0,
  },
  {
    index: 1,
    key: 'public',
    icon: 'bus',
    color: '#BC141A',
    transportType: 1,
    optimizedMaterial: true,
  },
  {
    index: 2,
    key: 'private',
    icon: 'car',
    color: '#45D2B2',
    transportType: 2,
    optimizedMaterial: true,
  },
  {
    index: 3,
    key: 'custom',
    icon: 'people_star',
    color: '#602376',
  },
  {
    index: 4,
    key: 'optimized',
    icon: 'chrono',
    color: '#F5A623',
  },
  {
    index: 5,
    key: 'bicycle',
    icon: 'cycle',
    color: '#3385A1',
    transportType: 3,
    optimizedMaterial: true,
  },
  {
    index: 6,
    key: 'walking',
    icon: 'walking',
    color: '#228b22',
    transportType: 4,
    optimizedMaterial: true,
  },
  {
    index: 7,
    key: 'public2025',
    icon: 'bus',
    color: '#BC141A',
    transportType: 7,
    optimizedMaterial: true,
  },
  {
    index: 8,
    key: 'public2030',
    icon: 'bus',
    color: '#BC141A',
    transportType: 8,
    optimizedMaterial: true,
  },
  {
    index: 9,
    key: 'public2027',
    icon: 'bus',
    color: '#BC141A',
    transportType: 9,
    optimizedMaterial: true,
  },
  {
    index: 10,
    key: 'public2031',
    icon: 'bus',
    color: '#BC141A',
    transportType: 10,
    optimizedMaterial: true,
  },
];
